<ag-grid-angular class="data-grid  margin-top" [rowData]="contacts | async" [gridOptions]="gridOptions" aria-label="Organization Contacts">
</ag-grid-angular>

@if (showModal == true) {
  <div class="dialogContainer">
    <div class="dialog">
      <div class="cell large-12 medium-12 small-12 bold">
        Change Legacy Contact Agent Type
      </div>
      @if (showModal == true && updateAgentTypeForm) {
        <div class="cell large-12 medium-12 small-12">
          <form [formGroup]="updateAgentTypeForm">
            <label for="name" class="bold">Name</label>
            <input id="name" type="text" formControlName="name" class="input-field" disabled />
            <label for="agentType" class="bold">Select Agent Type</label>
            <select id="agentType" formControlName="agentType">
              @for (type of agentTypes; track type) {
                <option [value]="type.id">{{type.value}}</option>
              }
            </select>
          </form>
        </div>
      }
      <div class="text-align-center">
        <button class="button margin-left no-margin-bottom outline-offset-1"  (click)="cancel()">Cancel</button>
        <button class="button margin-left no-margin-bottom outline-offset-1"  (click)="changeAgentType()">Save</button>
      </div>
    </div>
  </div>
}


